import { render, staticRenderFns } from "./VehBodyTypes.vue?vue&type=template&id=42d18094&"
import script from "./VehBodyTypes.vue?vue&type=script&lang=js&"
export * from "./VehBodyTypes.vue?vue&type=script&lang=js&"
import style0 from "./VehBodyTypes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VehBodyTypes.vue"
export default component.exports